/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_X13_Error_UnavailableInputs */

const en_portal_x13_error_unavailable = /** @type {(inputs: Portal_X13_Error_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in with this provider is not available right now. Try again or use the email link.`)
};

/** @type {(inputs: Portal_X13_Error_UnavailableInputs) => LocalizedString} */
const ar_portal_x13_error_unavailable = en_portal_x13_error_unavailable;

/** @type {(inputs: Portal_X13_Error_UnavailableInputs) => LocalizedString} */
const he_portal_x13_error_unavailable = en_portal_x13_error_unavailable;

/** @type {(inputs: Portal_X13_Error_UnavailableInputs) => LocalizedString} */
const ur_portal_x13_error_unavailable = en_portal_x13_error_unavailable;

/** @type {(inputs: Portal_X13_Error_UnavailableInputs) => LocalizedString} */
const es_portal_x13_error_unavailable = en_portal_x13_error_unavailable;

/** @type {(inputs: Portal_X13_Error_UnavailableInputs) => LocalizedString} */
const fr_portal_x13_error_unavailable = en_portal_x13_error_unavailable;

/** @type {(inputs: Portal_X13_Error_UnavailableInputs) => LocalizedString} */
const de_portal_x13_error_unavailable = en_portal_x13_error_unavailable;

/** @type {(inputs: Portal_X13_Error_UnavailableInputs) => LocalizedString} */
const pt_portal_x13_error_unavailable = en_portal_x13_error_unavailable;

/** @type {(inputs: Portal_X13_Error_UnavailableInputs) => LocalizedString} */
const hi_portal_x13_error_unavailable = en_portal_x13_error_unavailable;

/** @type {(inputs: Portal_X13_Error_UnavailableInputs) => LocalizedString} */
const bn_portal_x13_error_unavailable = en_portal_x13_error_unavailable;

/**
* | output |
* | --- |
* | "Sign-in with this provider is not available right now. Try again or use the email link." |
*
* @param {Portal_X13_Error_UnavailableInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portal_x13_error_unavailable = /** @type {((inputs?: Portal_X13_Error_UnavailableInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_X13_Error_UnavailableInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portal_x13_error_unavailable(inputs)
	if (locale === "he") return he_portal_x13_error_unavailable(inputs)
	if (locale === "ur") return ur_portal_x13_error_unavailable(inputs)
	if (locale === "es") return es_portal_x13_error_unavailable(inputs)
	if (locale === "fr") return fr_portal_x13_error_unavailable(inputs)
	if (locale === "de") return de_portal_x13_error_unavailable(inputs)
	if (locale === "pt") return pt_portal_x13_error_unavailable(inputs)
	if (locale === "hi") return hi_portal_x13_error_unavailable(inputs)
	if (locale === "bn") return bn_portal_x13_error_unavailable(inputs)
	return /** @type {LocalizedString} */ ("Sign-in with this provider is not available right now. Try again or use the email link.")
});